import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DocMasterCreateRequestDTO, DocMasterDeleteRequestDTO, DocMasterDTO, DocMasterList, DocMasterReadByDocTypeRequestDTO, DocMasterReadByIdRequestDTO, DocMasterReadByMasterIdRequestDTO, DocMasterUpdateRequestDTO } from "./docMaster.interface";
import { Observable } from "rxjs";
import { DocMaster_Create, DocMaster_Delete, DocMaster_ReadAll, DocMaster_ReadByDocType, DocMaster_ReadById, DocMaster_ReadByMasterId, DocMaster_Update } from "src/app/GlobalVariables";

@Injectable({
    providedIn: 'root'
})

export class DocMasterService {
    private http = inject(HttpClient);

    DocMaster_Create(data: DocMasterCreateRequestDTO): Observable<DocMasterDTO> {
        return this.http.post<DocMasterDTO>(DocMaster_Create, data);
    }

    DocMaster_Update(data: DocMasterUpdateRequestDTO): Observable<DocMasterDTO> {
        return this.http.post<DocMasterDTO>(DocMaster_Update, data);
    }

    DocMaster_ReadAll(): Observable<DocMasterList> {
        return this.http.get<DocMasterList>(DocMaster_ReadAll);
    }

    DocMaster_Delete(data: DocMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(DocMaster_Delete, data);
    }

    DocMaster_ReadById(data: DocMasterReadByIdRequestDTO): Observable<DocMasterDTO> {
        return this.http.post<DocMasterDTO>(DocMaster_ReadById, data);
    }

    DocMaster_ReadByDocType(data: DocMasterReadByDocTypeRequestDTO): Observable<DocMasterList> {
        return this.http.post<DocMasterList>(DocMaster_ReadByDocType, data);
    }

    DocMaster_ReadByMasterId(data: DocMasterReadByMasterIdRequestDTO): Observable<DocMasterList> {
        return this.http.post<DocMasterList>(DocMaster_ReadByMasterId, data);
    }
}